import React from "react";
import {T, useTranslate} from "@tolgee/react";
import {Tooltip, Typography} from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import {getLinkedPropertyLabel} from "tools/product/productLinkedProperties";
import {LinkedStandProperty} from "@evennt-tech/api-v2-core";
import useStyles from "../../styles";

const LinkedPropertyTooltip = ({
  propertyName,
}: {
  propertyName: LinkedStandProperty;
}) => {
  const classes = useStyles();
  const {t} = useTranslate();

  return (
    <Typography variant="h3">
      <T keyName="common.shopping_cart.your_price" />
      <Tooltip
        placement="bottom-start"
        title={
          <Typography className={classes.tooltipText}>
            <T
              keyName="common.shopping_cart.price_auto_calculated"
              params={{property: getLinkedPropertyLabel(propertyName, t)}}
            />
          </Typography>
        }
      >
        <InfoOutlinedIcon className={classes.infoIcon} />
      </Tooltip>
    </Typography>
  );
};

export default LinkedPropertyTooltip;
